export const gradableSections = ['a', 'b', 'c', 'd', 'e', 'f']
